import { NgModule } from '@angular/core';
import { CheckoutComponentsModule } from '@spartacus/checkout/base/components';
import { CheckoutOccModule } from '@spartacus/checkout/base/occ';
import { provideConfig } from '@spartacus/core';
import { knbrCheckoutTranslationChunksConfig, knbrCheckoutTranslations } from 'src/feature-libs/kn-br-checkout/base/assets/translation/translation';
import { CHECKOUT_FEATURE } from 'src/feature-libs/kn-br-checkout/base/root/feature-name';
import { KnBrCheckoutRootModule } from 'src/feature-libs/kn-br-checkout/base/root/kn-br-checkout-root.module';
@NgModule({
  imports: [KnBrCheckoutRootModule, CheckoutOccModule, CheckoutComponentsModule],
  providers: [
    provideConfig({
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () =>
            import('../../../../feature-libs/kn-br-checkout/kn-br-checkout.module').then((m) => m.KnBrCheckoutModule),
        },
      },
    }),
    provideConfig({
      i18n: {
        resources: knbrCheckoutTranslations,
        chunks: knbrCheckoutTranslationChunksConfig,
      },
    }),
  ],
})
export class CheckoutFeatureModule { }
